import { module as Module } from 'modujs';
import lottie from 'lottie-web';
import gsap from 'gsap';

export default class Process extends Module {
    static CLASS = {
        IS_ACTIVE: 'is-active'
    };

    constructor(m) {
        super(m);

        // UI
        this.$lottieContainer = this.$('lottieContainer')[0];
        this.lottiePath = this.getData('path');
        this.lottieAnim = null;
        this.$items = this.$('item');
        this.$sticky = this.$('sticky');

        this.currentStep = -1;
        this.totalSteps = this.$items.length;
        this.lottieTotalFrames = 0;
        this.currentFrame = -1;

        this.stepsRange = [
            {
                in: 0,
                out: 160
            },
            {
                in: 161,
                out: 280
            },
            {
                in: 281,
                out: 369
            },
            {
                in: 370,
                out: 480
            }
        ];
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        if (this.lottiePath) {
            this.loadLottie().then(() => {
                this.lottieTotalFrames = this.lottieAnim.totalFrames;
                // Need to set the total frames in process.scss to make the anchor work in --total-frames
                //this.el.style.setProperty('--total-frames', this.lottieTotalFrames)
                // requestAnimationFrame(() => {
                //     this.call('resize', null, 'Scroll')
                // })
            });
        }
    }

    destroy() {}

    ///////////////
    // Callbacks
    ///////////////

    onScrollProgress(progress) {
        const currentFrame = Math.round(
            gsap.utils.mapRange(0, 1, 0, this.lottieTotalFrames, progress)
        );

        if (currentFrame != this.currentFrame) {
            this.lottieAnim.goToAndStop(currentFrame, true);
            this.computeCurrentStep(currentFrame);
            this.currentFrame = currentFrame;
        }
    }

    ///////////////
    // Methods
    ///////////////

    loadLottie() {
        return new Promise((resolve) => {
            this.lottieAnim = lottie.loadAnimation({
                path: this.lottiePath,
                container: this.$lottieContainer,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                }
            });

            this.lottieAnim.addEventListener('DOMLoaded', resolve);
        });
    }

    computeCurrentStep(currentFrame) {
        this.stepsRange.forEach((step, index) => {
            if (
                currentFrame >= step.in &&
                currentFrame <= step.out &&
                !this.$items[index].classList.contains('is-active')
            ) {
                this.$items[index].classList.add('is-active');
            } else if (
                (currentFrame < step.in || currentFrame > step.out) &&
                this.$items[index].classList.contains('is-active')
            ) {
                if (index == this.totalSteps - 1 && currentFrame > step.out) return;
                this.$items[index].classList.remove('is-active');
            }

            if (currentFrame >= step.out && !this.$items[index].classList.contains('is-past')) {
                if (index == this.totalSteps - 1) return;
                this.$items[index].classList.add('is-past');
            } else if (
                currentFrame < step.out &&
                this.$items[index].classList.contains('is-past')
            ) {
                this.$items[index].classList.remove('is-past');
            }
        });
    }
}
